export default __webpack_public_path__ + "static/media/gauge-face.7189f8a9.png";